import { useEffect } from "react";
import { CardWrapper } from "../../components/CardWrapper/CardWrapper";
import { ChannelLink } from "../../components/Links/ChannelLink/ChannelLink";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock"
import { useDispatch, useSelector } from "../../hooks";
import styles from "./DrawWinnersPage.module.scss";
import { WinnerCard } from "./WinnerCard/WinnerCard";
import { getDrawsWinners } from "../../redux/draws/get-winners.handler";
import { CustomPagination } from "../../components/CustomPagination/CustomPagination";
import { getPlatformText } from "../../utils/platform-text";

export const DrawWinnersPage = () => {
    const { data } = useSelector(store => store.draws.winners);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getDrawsWinners(1));
    }, [dispatch]);
    
    const getDescription = () => {
        return (
            <>
                <span>Обьявления победителей можно посмотреть в нашем </span>
                <ChannelLink caption={getPlatformText("channelIn")} />
            </>
        );
    }
    
    return (
        <div className={styles.cardWrapper}>
            <PageTitleBlock
                pageTitle="Победители розыгрышей"
                pageDescription={ getDescription() }
            />

            <CardWrapper>
                { (data?.length ?? 0) === 0 && (
                    <span className={styles.noTasks}>Пока победителей нет</span>
                )}
                { (data ?? []).map((winner) => (
                    <WinnerCard key={winner.userId} {...winner} />
                )) }
            </CardWrapper>

            <CustomPagination
                pageChangeHandler= { (page: number) => dispatch(getDrawsWinners(page)) }
                selector={ store => store.draws.winners.pagination }
            />
        </div>
    );
}